/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Message_PassingInputs */

const en_svchip_message_passing = /** @type {(inputs: Svchip_Message_PassingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message passing`)
};

const ar_svchip_message_passing = /** @type {(inputs: Svchip_Message_PassingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تمرير الرسائل`)
};

const bn_svchip_message_passing = /** @type {(inputs: Svchip_Message_PassingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মেসেজ পাসিং`)
};

const de_svchip_message_passing = /** @type {(inputs: Svchip_Message_PassingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachrichtenübermittlung`)
};

const es_svchip_message_passing = /** @type {(inputs: Svchip_Message_PassingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paso de mensaje`)
};

const fr_svchip_message_passing = /** @type {(inputs: Svchip_Message_PassingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passage de messages`)
};

const pt_svchip_message_passing = /** @type {(inputs: Svchip_Message_PassingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passagem de mensagem`)
};

const zh_svchip_message_passing = /** @type {(inputs: Svchip_Message_PassingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消息传递`)
};

const tr_svchip_message_passing = /** @type {(inputs: Svchip_Message_PassingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İleti iletiliyor`)
};

const ru_svchip_message_passing = /** @type {(inputs: Svchip_Message_PassingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Передача сообщений`)
};

const pl_svchip_message_passing = /** @type {(inputs: Svchip_Message_PassingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przekazywanie wiadomości`)
};

/**
* | output |
* | --- |
* | "Message passing" |
*
* @param {Svchip_Message_PassingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_message_passing = /** @type {((inputs?: Svchip_Message_PassingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Message_PassingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_message_passing(inputs)
	if (locale === "bn") return bn_svchip_message_passing(inputs)
	if (locale === "de") return de_svchip_message_passing(inputs)
	if (locale === "es") return es_svchip_message_passing(inputs)
	if (locale === "fr") return fr_svchip_message_passing(inputs)
	if (locale === "pt") return pt_svchip_message_passing(inputs)
	if (locale === "zh") return zh_svchip_message_passing(inputs)
	if (locale === "tr") return tr_svchip_message_passing(inputs)
	if (locale === "ru") return ru_svchip_message_passing(inputs)
	if (locale === "pl") return pl_svchip_message_passing(inputs)
	return en_svchip_message_passing(inputs)
});